import React, { Component } from 'react';
import { Row, Col, Button, Icon } from '$common';
import CSSModules from 'react-css-modules';
import style from './filters.scss';
import { browserHistory } from 'react-router';

@CSSModules(style, { allowMultiple: true })
export default class Filters extends Component {
  state = {
    filterSectionOpened: false
  }

  clearFilter() {
    this.props.onClearFilters();

    browserHistory.push({
      pathname: window.location.pathname,
      query: {}
    });
  }

  render() {
    const { filterSectionOpened } = this.state;
    const { advancedFilters, defaultFilters } = this.props;

    return (
      <div styleName="root" id="filters">
        {
          advancedFilters ?
            <div styleName={filterSectionOpened ? 'filter-wrapper active' : 'filter-wrapper'}>
              <Row>
                <Col md="4/5" gutter={20}>
                  {defaultFilters}
                </Col>
                <Col md="1/5" gutter={20}>
                  <Button
                    type="weak"
                    block
                    onClick={() => {
                      filterSectionOpened ? this.setState({ filterSectionOpened: false }) : this.setState({ filterSectionOpened: true });
                      // window.Intercom('trackEvent', 'OPENED_SUBMISSIONS_SEARCH');
                    }}
                    id="live-filter-open-button"
                  >
                    Advanced Search <Icon name={filterSectionOpened ? 'angle-up' : 'angle-down'} />
                  </Button>
                </Col>
              </Row>
              <div styleName="other-filters">
                {advancedFilters}
                <div styleName="form-field">
                  <Row>
                    <Col md="1/2" gutter={20}>
                      <Button type="ghost" block onClick={() => this.clearFilter()}><Icon name="times"/>  Clear Search</Button>
                    </Col>
                    <Col md="1/2" gutter={20}>
                      <Button type="success" block onClick={() => {
                        this.setState({ filterSectionOpened: false })
                        // window.Intercom('trackEvent', 'SEARCHED_SUBMISSIONS');
                      }} id="live-filter-apply-button">Apply</Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          :
            <div styleName="filter-wrapper">
              {defaultFilters}
            </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/project/show/submissions/filters/filters.js